<template>
    <div class="device-product-row mb-5">
        <div class="flex items-center">
            <span class="font-medium">N° {{ device.number }}</span>
            <div class="flex items-center space-x-2">
                <span class="ml-2"> - </span>
                <img :src="device.device_types[device.device_types.length - 1].icon" alt="picto" style="max-width: 15px;" />
                <span class="">{{ device.device_types[device.device_types.length - 1].name }}</span>
                <span class="italic">({{ device.location }})</span>
            </div>
        </div>
        <div>
            <md-button class="md-icon-button md-info" @click="addProduct">
                <span class="font-medium">Ajouter un produit</span>
            </md-button>
        </div>
        <template v-if="device.products.length > 0">
            <product-row v-for="(product, index) in device.products" :key="product.id" :index="index"
                         :product="product" :products="products" :deviceId="device.id"
                         :errors="productErrors" @deleted="$emit('deleted')" @remove="removeProduct"></product-row>
        </template>
        <p v-else>Aucun produit pour ce dispositif.</p>
    </div>
</template>

<script>
import ProductRow from "@/pages/Sites/Devices/Products/ProductRow";

export default {
    name: "DeviceProductRow",
    components: {
        ProductRow
    },
    props: {
        device: Object,
        products: Array,
        errors: Array,
        index: Number
    },
    data() {
        return {
            productErrors: []
        }
    },
    methods: {
        addProduct() {
            this.device.products.push({
                tempId: 'temp-' + this.device.products.length + '-' + Math.floor(Math.random() * (9999 - 1000 + 1) + 1000),
                newId: null,
                newQuantity: null,
            })
        },
        removeProduct(e) {
            this.device.products = this.device.products.filter(product => {
                return product.tempId === null || product.tempId === undefined || product.tempId !== e.tempId
            })
        }
    },
    watch: {
        errors(newVal) {
            if(newVal) {
                let errors = []
                newVal.map(error => {
                    let parts = error.source.pointer.split('.')
                    if(this.index === parseInt(parts[1])) {
                        errors.push(error)
                    }
                })
                this.productErrors = errors
            }
        }
    }
}
</script>

<style scoped lang="scss">
.device-product-row:last-child {
    margin-bottom: 0 !important;
}
</style>
